// extracted by mini-css-extract-plugin
export default {"zr-link":"Link_zr-link__NjXwL"};